import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import { TextField, Typography, Checkbox, Hidden, TableCell, Container, TableRow, Tooltip, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import { istInteger } from "../lib";
import TimeInput from "../shared/components/TimeInput";

export default function Child(props) {
  useEffect(() => {
    setSpalte(props.spalte);
    // eslint-disable-next-line
  }, [props.spalte]);
  const [spalte, setSpalte] = useState([]);
  const { status, genehmigen, index, aufgabe, zeile, datum, antragsteller, small, newtime } = props;
  const [item, setItem] = useState(props.zeile);
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    setItem(zeile);
    // eslint-disable-next-line
    // console.log(item)
  }, [zeile]);
  function prec(n) {
    if (!isFinite(n)) return 0;
    var e = 1,
      p = 0;
    while (Math.round(n * e) / e !== n) {
      e *= 10;
      p++;
    }
    return p;
  }
  const onChange = (event, sindex, feld, format) => {
    console.log(event);
    let newValue = event;
    console.log(format);
    if (format === "GANZZAHL" && istInteger(event) === false) {
      return;
    }
    if (format === "KOMMAZAHL" && prec(Number(newValue)) > 2) {
      return;
    }

    if (sindex === -1) {
      setItem((prevState) => {
        let newItem = { ...prevState };
        newItem[feld] = newValue;
        // sync with [arent array]
        props.onChange(props.index, newItem);

        return newItem;
      });
    } else {
      var zusatz = "";
      if (Number(newValue) === 0 || !newValue || newValue === "") {
        item.spalten.forEach((tmpitem, tmpindex) => {
          if (tmpindex === sindex) return;
          if (tmpitem[feld] && Number(tmpitem[feld]) !== 0 && tmpitem[feld] !== "") {
            zusatz = " - Eingaben vorhanden";
          }
        });
      } else {
        zusatz = " - Eingaben vorhanden";
      }

      setItem((prevState) => {
        let newItem = { ...prevState };
        newItem.spalten[sindex][feld] = newValue;
        newItem.zusatz = zusatz;
        // sync with [arent array]
        props.onChange(props.index, newItem);
        return newItem;
      });
    }
  };
  const onChangeM = (event, sindex, feld, format) => {
    let newValue = event;
    if (format === "GANZZAHL" && istInteger(event) === false) {
      return;
    }
    setItem((prevState) => {
      let newItem = { ...prevState };

      newItem[sindex][feld] = newValue;
      // sync with [arent array]
      props.onChange(sindex, newItem[sindex]);
      return newItem;
    });
  };
  const onClick = (index) => {
    props.onClick(index);
  };
  const tableRowStyle = () => {
    if (item.gesperrt && item.gesperrt === "1" && item.sperrgrund && item.sperrgrund !== "") {
      return small ? { cursor: "pointer", backgroundColor: "rgba(190,190,200,0.5)" } : { backgroundColor: "rgba(190,190,200,0.5)" };
    }
    return small ? { cursor: "pointer" } : {};
  };
  const tableChipStyle = (red, green, blue) => {
    if (red) {
      return { backgroundColor: `rgba(${red},${green},${blue},0.5)` };
    } else {
      return {};
    }
  };

  return (
    <Fragment>
      {aufgabe === "alles" && item && (
        <TableRow
          key={"zeile" + index}
          style={tableRowStyle()}
          onClick={() => (small && (item.gesperrt !== "1" || (status !== "O" && status !== "A")) ? onClick(index) : {})}
          hover={small && (item.gesperrt !== "1" || (status !== "O" && status !== "A"))}
        >
          <Hidden lgUp>
            <TableCell align="left">
              <Grid container>
                <Grid item xs={12}>
                  <div style={{ fontWeight: "700" }}>{item.datum}</div>
                </Grid>
                <Grid item xs={12}>
                  {item.info2 && item.info2 !== "" ? (
                    <div style={item.red ? tableChipStyle(item.red, item.green, item.blue) : { backgroundColor: `rgba(${"255"},${"255"},${"255"},0)` }}>
                      {item.info2}
                      {item.zusatz && item.zusatz !== "" && item.zusatz}
                    </div>
                  ) : (
                    <div>{item.zusatz && item.zusatz !== "" ? item.zusatz : "-"}</div>
                  )}
                </Grid>
              </Grid>
            </TableCell>
          </Hidden>
          <Hidden lgDown>
            <TableCell>
              <Container>
                <Typography component="div">{item.datum}</Typography>
              </Container>
            </TableCell>
            <Hidden lgDown>
              <TableCell align="center">
                {item.info && item.info !== "" && (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={item.red ? tableChipStyle(item.red, item.green, item.blue) : { backgroundColor: `rgba(${"255"},${"255"},${"255"},0)` }}
                    >
                      <Typography fullWidth>{item.info}</Typography>
                    </Grid>
                  </Grid>
                )}
              </TableCell>
            </Hidden>
            <Hidden lgUp>
              <TableCell align="center">
                {item.info2 && item.info2 !== "" && (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={item.red ? tableChipStyle(item.red, item.green, item.blue) : { backgroundColor: `rgba(${"255"},${"255"},${"255"},0)` }}
                    >
                      <Typography fullWidth>{item.info2}</Typography>
                    </Grid>
                  </Grid>
                )}
              </TableCell>
            </Hidden>
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Hidden lgDown>
                <TableCell>
                  <Tooltip title={item.hinweisvg}>
                    <TextField
                      id={"hinweisvg" + index}
                      disabled={genehmigen !== "1" || status === "P" || status === "K"}
                      value={item.hinweisvg}
                      onChange={(e) => onChange(e.target.value, -1, "hinweisvg", "")}
                      variant="outlined"
                      size="small"
                      style={genehmigen === "1" ? { backgroundColor: theme.palette.blocks.hyellow } : {}}
                    />
                  </Tooltip>
                </TableCell>
              </Hidden>
            )}
            {spalte.map((sitem, sindex) => {
              return (
                <Hidden lgDown>
                  <TableCell>
                    {sitem.feldart !== "Checkbox" && (
                      <Fragment>
                        {(sitem.format !== "ZEIT" || !newtime) && (
                          <TextField
                            id={"spalte" + sindex}
                            disabled={
                              (status !== "O" && status !== "A") ||
                              (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                              item.gesperrt === "1" ||
                              sitem.feldart === "Info" ||
                              sitem.feldart === "SFELD" ||
                              sitem.feldart === "RFELD"
                            }
                            value={item.spalten[sindex] ? item.spalten[sindex]?.wert : ""}
                            variant="outlined"
                            type={
                              sitem.format === "DATUM"
                                ? "date"
                                : sitem.format === "ZEIT"
                                ? "time"
                                : sitem.format === "GANZZAHL"
                                ? "text"
                                : sitem.format === "KOMMAZAHL"
                                ? "number"
                                : ""
                            }
                            onChange={(e) => onChange(e.target.value, sindex, "wert", sitem.format)}
                            fullWidth
                            size="small"
                          />
                        )}
                        {sitem.format === "ZEIT" && newtime && (
                          <TimeInput
                            disabled={
                              (status !== "O" && status !== "A") ||
                              (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                              item.gesperrt === "1" ||
                              sitem.feldart === "Info" ||
                              sitem.feldart === "SFELD" ||
                              sitem.feldart === "RFELD"
                            }
                            value={item.spalten[sindex] ? item.spalten[sindex]?.wert : ""}
                            variant="outlined"
                            onChange={(e) => onChange(e, sindex, "wert", sitem.format)}
                            fullWidth
                            size="small"
                          />
                        )}
                      </Fragment>
                    )}
                    {sitem.feldart === "Checkbox" && (
                      <Checkbox
                        checked={item.spalten[sindex] && item.spalten[sindex]?.wert === "1"}
                        onChange={(e) => onChange(e.target.checked ? "1" : "0", sindex, "wert", "")}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                          item.gesperrt === "1" ||
                          sitem.feldart === "Info" ||
                          sitem.feldart === "SFELD" ||
                          sitem.feldart === "RFELD"
                        }
                        size="small"
                      />
                    )}
                  </TableCell>
                </Hidden>
              );
            })}
          </Hidden>
        </TableRow>
      )}
      {aufgabe === "zeile" && (
        <Grid container spacing={2} justifyContent="center" alignItems="flex-end">
          <Grid item xs={12}>
            {genehmigen === "1" && (
              <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField id="annr" label={t("Antragsteller")} fullWidth disabled value={antragsteller} variant="filled" />
                </Grid>
              </Grid>
            )}
            <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField id={"datum"} disabled value={item.datum} variant="filled" fullWidth label={t("Datum")} />
              </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id={"info"}
                  disabled
                  value={item.info}
                  variant="filled"
                  fullWidth
                  label={t("Info")}
                  style={item.red && { backgroundColor: `rgba(${item.red},${item.green},${item.blue},0.5)` }}
                />
              </Grid>
            </Grid>
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id={"hinweisvg"}
                    disabled={genehmigen !== "1" || status === "P" || status === "K"}
                    value={item.hinweisvg}
                    fullWidth
                    onChange={(e) => onChange(e.target.value, -1, "hinweisvg", "")}
                    variant={genehmigen !== "1" || status === "P" || status === "K" ? "filled" : "outlined"}
                    style={genehmigen === "1" ? { backgroundColor: theme.palette.blocks.hyellow } : {}}
                    label={t("Kommentar Vorgesetzter")}
                    multiline
                  />
                </Grid>
              </Grid>
            )}
            {spalte.map((sitem, sindex) => (
              <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
                <Grid item xs={12} sm={6}>
                  {sitem.feldart !== "Checkbox" && (
                    <Fragment>
                      {(sitem.format !== "ZEIT" || !newtime) && (
                        <TextField
                          id={"spalte" + sindex}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                            item.gesperrt === "1" ||
                            sitem.feldart === "Info" ||
                            sitem.feldart === "SFELD" ||
                            sitem.feldart === "RFELD"
                          }
                          value={item.spalten[sindex] ? item.spalten[sindex]?.wert : ""}
                          variant={
                            (status !== "O" && status !== "A") ||
                            (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                            item.gesperrt === "1" ||
                            sitem.feldart === "Info" ||
                            sitem.feldart === "SFELD" ||
                            sitem.feldart === "RFELD"
                              ? "filled"
                              : "outlined"
                          }
                          type={
                            sitem.format === "DATUM"
                              ? "date"
                              : sitem.format === "ZEIT"
                              ? "time"
                              : sitem.format === "GANZZAHL"
                              ? "text"
                              : sitem.format === "KOMMAZAHL"
                              ? "number"
                              : ""
                          }
                          onChange={(e) => onChange(e.target.value, sindex, "wert", sitem.format)}
                          fullWidth
                          label={sitem.bez}
                        />
                      )}
                      {sitem.format === "ZEIT" && newtime && (
                        <TimeInput
                          id={"spalte" + sindex}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                            item.gesperrt === "1" ||
                            sitem.feldart === "Info" ||
                            sitem.feldart === "SFELD" ||
                            sitem.feldart === "RFELD"
                          }
                          value={item.spalten[sindex] ? item.spalten[sindex]?.wert : ""}
                          variant={
                            (status !== "O" && status !== "A") ||
                            (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                            item.gesperrt === "1" ||
                            sitem.feldart === "Info" ||
                            sitem.feldart === "SFELD" ||
                            sitem.feldart === "RFELD"
                              ? "filled"
                              : "outlined"
                          }
                          onChange={(e) => onChange(e, sindex, "wert", sitem.format)}
                          fullWidth
                          label={sitem.bez}
                        />
                      )}
                    </Fragment>
                  )}
                  {sitem.feldart === "Checkbox" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={item.spalten[sindex] && item.spalten[sindex]?.wert === "1"}
                          onChange={(e) => onChange(e.target.checked ? "1" : "0", sindex, "wert", "")}
                          disabled={
                            (status !== "O" && status !== "A") ||
                            (item.spalten[sindex] && item.spalten[sindex].gesperrt) ||
                            item.gesperrt === "1" ||
                            sitem.feldart === "Info" ||
                            sitem.feldart === "SFELD" ||
                            sitem.feldart === "RFELD"
                          }
                        />
                      }
                      label={sitem.bez}
                    />
                  )}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
      {aufgabe === "allesmonat" && (
        <Fragment>
          <Hidden lgUp>
            {spalte?.map((sitem, sindex) => (
              <TableRow key={"zeile" + index} style={small ? { cursor: "pointer" } : {}} onClick={() => (small ? onClick(sindex) : {})} hover={small}>
                <TableCell align="left">
                  <Grid container>
                    <Grid item xs={12}>
                      <div style={{ fontWeight: "700" }}>{sitem.bez}</div>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
          </Hidden>
          <Hidden lgDown>
            <TableRow key={"zeile" + index} style={small ? { cursor: "pointer" } : {}} onClick={() => (small ? onClick(index) : {})} hover={small}>
              <TableCell>
                <Container>
                  <Typography component="div">{datum}</Typography>
                </Container>
              </TableCell>
              {spalte?.map((sitem, sindex) => (
                <Hidden lgDown>
                  <TableCell>
                    {sitem.feldart !== "Checkbox" && (
                      <TextField
                        id={"spalte" + sindex}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1" ||
                          sitem.feldart === "Info" ||
                          sitem.feldart === "SFELD" ||
                          sitem.feldart === "RFELD"
                        }
                        value={item[sindex]?.wert}
                        variant="outlined"
                        type={
                          sitem.format === "DATUM"
                            ? "date"
                            : sitem.format === "ZEIT"
                            ? "time"
                            : sitem.format === "GANZZAHL"
                            ? "text"
                            : sitem.format === "KOMMAZAHL"
                            ? "number"
                            : ""
                        }
                        onChange={(e) => onChangeM(e.target.value, sindex, "wert", sitem.format)}
                        fullWidth
                        size="small"
                      />
                    )}
                    {sitem.feldart === "Checkbox" && (
                      <Checkbox
                        checked={item[sindex]?.wert === "1"}
                        onChange={(e) => onChangeM(e.target.checked ? "1" : "0", sindex, "wert", "")}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1" ||
                          sitem.feldart === "Info" ||
                          sitem.feldart === "SFELD" ||
                          sitem.feldart === "RFELD"
                        }
                        size="small"
                      />
                    )}
                  </TableCell>
                </Hidden>
              ))}
            </TableRow>
          </Hidden>
        </Fragment>
      )}
      {aufgabe === "zeilemonat" && (
        <Grid container spacing={2} justifyContent="center" alignItems="flex-end">
          <Grid item xs={12}>
            {genehmigen === "1" && (
              <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField id="annr" label={t("Antragsteller")} fullWidth disabled value={antragsteller} variant="filled" />
                </Grid>
              </Grid>
            )}
            <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField id={"datum"} disabled value={datum} variant="filled" fullWidth label={t("Datum")} />
              </Grid>
            </Grid>
            {spalte.map((sitem, sindex) => {
              if (index !== sindex) return <Fragment />;
              return (
                <Grid container justifyContent="center" alignItems="flex-end" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    {sitem.feldart !== "Checkbox" && (
                      <TextField
                        id={"spalte" + sindex}
                        disabled={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1" ||
                          sitem.feldart === "Info" ||
                          sitem.feldart === "SFELD" ||
                          sitem.feldart === "RFELD"
                        }
                        value={item[sindex]?.wert}
                        variant={
                          (status !== "O" && status !== "A") ||
                          item.gesperrt === "1" ||
                          sitem.feldart === "Info" ||
                          sitem.feldart === "SFELD" ||
                          sitem.feldart === "RFELD"
                            ? "filled"
                            : "outlined"
                        }
                        type={
                          sitem.format === "DATUM"
                            ? "date"
                            : sitem.format === "ZEIT"
                            ? "time"
                            : sitem.format === "GANZZAHL"
                            ? "text"
                            : sitem.format === "KOMMAZAHL"
                            ? "number"
                            : ""
                        }
                        onChange={(e) => onChangeM(e.target.value, sindex, "wert", sitem.format)}
                        fullWidth
                        label={sitem.bez}
                      />
                    )}
                    {sitem.feldart === "Checkbox" && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={item[sindex]?.wert === "1"}
                            onChange={(e) => onChangeM(e.target.checked ? "1" : "0", sindex, "wert", "")}
                            disabled={
                              (status !== "O" && status !== "A") ||
                              item.gesperrt === "1" ||
                              sitem.feldart === "Info" ||
                              sitem.feldart === "SFELD" ||
                              sitem.feldart === "RFELD"
                            }
                          />
                        }
                        label={sitem.bez}
                      />
                    )}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}
